import styled from '@emotion/styled'
import * as api from "api"
import RatioElement from "common/ElementRatio"
import ResponsiveModelImage from "common/ResponsiveModelImage"
import { memo } from "react"
import Shared from "theme/shared"

const Styled = {
  Wrapper: styled.div`
    overflow: hidden;
    width: 100%;
    max-width: 1026px;
    ${(p) => p.theme.breakpoints.up("md")} {
      margin: 70px auto 0;
    }
  `,
  Header: styled(Shared.Header)`
    padding: 0 15px;
  `,
  InnerGrid: styled.div`
    margin-top: 5px;
    flex: 1;
    ${(p) => p.theme.breakpoints.up("md")} {
      flex: 0 1 calc(50% - 5px);
    }
  `,
  Grid: styled.div`
    display: flex;
    flex-direction: column;
    margin: 10px 15px 20px;
    justify-content: center;
    ${(p) => p.theme.breakpoints.up("md")} {
      flex-direction: row;
      flex-wrap: wrap;
      margin: 50px 15px 90px;
    }
  `,
}

type VehiclePolutionProps = { data: api.ImageModel[] }

const VehiclePolution = ({ data }: VehiclePolutionProps) => (
  <Styled.Wrapper>
    <Styled.Header>פליטת מזהמים וצריכת דלק</Styled.Header>
    <Shared.Mobile>
      <Shared.Divider />
    </Shared.Mobile>
    <Styled.Grid>
      {data.map((image, i) => (
        <Styled.InnerGrid key={i}>
          <RatioElement ratio={462 / 272}>
            <ResponsiveModelImage image={image} />
          </RatioElement>
        </Styled.InnerGrid>
      ))}
    </Styled.Grid>
  </Styled.Wrapper>
)

export default memo(VehiclePolution)
